module.exports = __webpack_public_path__ + "static/media/Q.69db0410.png";